import { useMutation } from "@apollo/client";
import { MT_SEND_MESSAGE } from "../graphQl/MessengerAPI";

export const useSendMessage = () => {
  const [sendMessageMutation, { loading, error }] =
    useMutation(MT_SEND_MESSAGE);

  const sendMessage = (message) => {
    return sendMessageMutation({
      variables: { message },
    });
  };

  return { sendMessage, loading, error };
};
